import { render } from "./Pagination_bouton_fleche.vue?vue&type=template&id=5a6f183c"
import script from "./Pagination_bouton_fleche.vue?vue&type=script&lang=js"
export * from "./Pagination_bouton_fleche.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Alexandre-OlivierRenaud/formateurs-autorises/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__